import step1Image from '../../assets/img/Onboarding/step1.svg';
import step2Image from '../../assets/img/Onboarding/step2.svg';
import step3Image from '../../assets/img/Onboarding/step3.svg';
import step4Image from '../../assets/img/Onboarding/step4.svg';
import step5Image from '../../assets/img/Onboarding/step5.svg';
import step6Image from '../../assets/img/Onboarding/step6.svg';

const onBoardingData = [
  {
    title: 'Bem-vinda!',
    description:
      'Olá! Seja bem-vinda ao aplicativo da Associação Marta. Nossa missão é atuar na prevenção e conscientização da violência contra a mulher.',
    step: 1,
    image: step1Image,
    alt: 'passo 1',
  },
  {
    title: 'O que é a Associação Marta?',
    description:
      'A Associação Marta é uma associação formada por mulheres que promove o acolhimento de vítimas de violência contra a mulher.',
    step: 2,
    image: step2Image,
    alt: 'passo 2',
  },
  {
    title: 'Conhecimento nas suas mãos',
    description:
      'Aprenda a distinguir os tipos de violência de gênero, entenda como a violência acontece e conheça as leis e serviços que garantem os direitos das mulheres.',
    step: 3,
    image: step3Image,
    alt: 'passo 3',
  },
  {
    title: 'Atendimentos gratuitos',
    description:
      'Marque um dia e horário para receber assistência da Associação Marta. Obtenha conforto psicológico e orientação jurídica de profissionais.',
    step: 4,
    image: step4Image,
    alt: 'passo 4',
  },
  {
    title: 'Botão de Pânico',
    description:
      'Solicite ajuda de forma segura utilizando o botão de pânico. Ao ser acionado, um número de emergência será discado no seu aplicativo de chamadas.',
    step: 5,
    image: step5Image,
    alt: 'passo 5',
  },
  {
    title: 'Caminho para o acolhimento',
    description:
      'Encontre o serviço de acolhimento mais perto de você e consulte informações como endereço, telefone e horário de atendimento.',
    step: 6,
    image: step6Image,
    alt: 'passo 6',
  },
];

export default onBoardingData;
